import { icon } from '@carvana/ds-styles';
import cx from 'classnames';
import { AlertTriangle } from 'lucide-react';
import { useVehicleAvailability } from '~/context/vdp/UserVehicleContext';
import { CurrentWipStatus } from '~/contracts/vdp/Availability';
import DelayedDisplayWrapper from './DelayedDisplayWrapper';
import ProgressBar from './ProgressBar';
import { Description, HeadingContent, Wrapper } from '../Banners.styles';

const content = {
  [CurrentWipStatus.ReconditioningAndDetailing]: {
    heading: 'Reconditioning complete',
    content:
      'We’re working on photographing your vehicle in 360°, inside and out.'
  },
  [CurrentWipStatus.Unknown]: {
    heading: 'You’ve pre-ordered this vehicle',
    content:
      'We’ll work on inspecting this vehicle to ensure it meets our standards.'
  },
  [CurrentWipStatus.VehicleInspection]: {
    heading: 'Inspection complete',
    content:
      'Next, your vehicle will undergo our reconditioning and detailing process.'
  },
  [CurrentWipStatus.Kicked]: {
    heading: 'This vehicle didn’t pass inspection',
    content:
      "Unfortunately, this vehicle did not meet our quality standards. We apologize for the inconvenience. Your reservation will be canceled and we'll refund the deposit."
  }
};

const step: Record<CurrentWipStatus, number> = {
  [CurrentWipStatus.Unknown]: 1,
  [CurrentWipStatus.VehicleInspection]: 2,
  [CurrentWipStatus.ReconditioningAndDetailing]: 3,
  [CurrentWipStatus.Kicked]: 0
};

export default function WIPReservedByUserProgress() {
  const {
    currentWipStatus: { status: wipStatus = CurrentWipStatus.Unknown } = {}
  } = useVehicleAvailability();
  const isKickedStatus = wipStatus === CurrentWipStatus.Kicked;

  return (
    <DelayedDisplayWrapper currentStep={step[wipStatus]}>
      <Wrapper
        className={cx('gap-2xl', {
          'bg-background-critical-subtle': isKickedStatus
        })}
      >
        <div className="flex flex-col gap-md ">
          <HeadingContent
            className={cx({
              'flex items-center gap-md text-text-strong': isKickedStatus
            })}
          >
            {isKickedStatus && (
              <AlertTriangle color={icon.critical} size={16} />
            )}
            {content[wipStatus].heading}
          </HeadingContent>
          <Description
            className={cx({
              'text-text-default': isKickedStatus
            })}
          >
            {content[wipStatus].content}
          </Description>
        </div>
        {!isKickedStatus && <ProgressBar currentStep={step[wipStatus]} />}
      </Wrapper>
    </DelayedDisplayWrapper>
  );
}
